import { resolveAbsoluteMediaUrl, resolveMediaUrl } from '~/utils/mediaUrl'

export function useMediaUrl() {
  const config = useRuntimeConfig()
  const apiOrigin = config.public.apiOrigin as string

  function mediaUrl(url?: string | null) {
    return resolveMediaUrl(url, apiOrigin)
  }

  function absoluteMediaUrl(url?: string | null) {
    return resolveAbsoluteMediaUrl(url, config.public.siteUrl as string, apiOrigin)
  }

  return { mediaUrl, absoluteMediaUrl }
}
